module.exports = __webpack_public_path__ + "img/雅思專區.a6fc851a.png";